import { useEffect, useState } from "react";
import { TrendingUp } from "lucide-react";
import { api } from "../../lib/api";

const LABEL = { bug: "Not working", ai_quality: "AI quality", lost_work: "Lost work", billing: "Billing", audio: "Audiobook", print: "Print/ebook", other: "Other" };
const mon = (k) => new Date(`${k}-01T00:00:00`).toLocaleDateString(undefined, { month: "short", year: "2-digit" });

export function IssueTrends() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/support/trends?months=6").then((r) => setD(r.data)).catch(() => setD({ error: true })); }, []);
  if (!d) return null;
  if (d.error) return <p className="panel p-4 text-xs text-red-400" data-testid="issue-trends-error">Couldn't load issue trends.</p>;
  return (
    <div className="panel p-5 overflow-x-auto scrollbar-thin" data-testid="issue-trends">
      <p className="eyebrow mb-1 flex items-center gap-1"><TrendingUp size={12} />Issue trends · last 6 months</p>
      <p className="text-xs text-slate-500 mb-3" data-testid="issue-trends-top">{d.top ? <>Fix first: <span className="text-amber-200">{LABEL[d.top]}</span> ({d.totals[d.top]} reports)</> : "No reports yet."}</p>
      <table className="w-full text-xs min-w-[640px]">
        <thead className="text-slate-500 text-left"><tr className="border-b border-slate-800">
          <th className="px-3 py-2 font-normal">Month</th>{d.categories.map((c) => <th key={c} className="px-3 py-2 font-normal">{LABEL[c]}</th>)}<th className="px-3 py-2 font-normal">Total</th>
        </tr></thead>
        <tbody>
          {[...d.months].reverse().map((m) => (
            <tr key={m.month} className="border-b border-slate-800/60 text-slate-300" data-testid={`issue-trend-row-${m.month}`}>
              <td className="px-3 py-2">{mon(m.month)}</td>
              {d.categories.map((c) => <td key={c} className={`px-3 py-2 ${m.top === c ? "text-amber-200 font-semibold bg-amber-500/10" : m.counts[c] ? "" : "text-slate-600"}`} data-testid={m.top === c ? `issue-trend-top-${m.month}` : undefined}>{m.counts[c] || "—"}</td>)}
              <td className="px-3 py-2">{m.total}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
